class Auth {
    isAuthenticated() {
        if (localStorage.getItem('api_token') && localStorage.getItem('user_type')) {
            return true;
        } else {
            return false;
        }
    }

    isUser() {
        if (localStorage.getItem('user_type') && localStorage.getItem('user_type') === 'user') {
            return true;
        } else {
            return false;
        }
    }

    isAdmin() {
        if (localStorage.getItem('user_type') && localStorage.getItem('user_type') === 'admin') {
            return true;
        } else {
            return false;
        }
    }

    isSuperAdmin() {
        if (localStorage.getItem('user_type') && localStorage.getItem('user_type') === 'super_admin') {
            return true;
        } else {
            return false;
        }
    }

    /**
     * Logga in användaren
     */
    login(token, type) {
        // Sätt token och vilken typ av användare
        localStorage.setItem('api_token', token);
        localStorage.setItem('user_type', type);

        // Skicka tillbaka användaren till startsidan först efter att det är garanterat att data sparats till localStorage
        (function waitForToken() {
            if (localStorage.getItem('api_token') && localStorage.getItem('user_type')) {
                window.location.reload();
            } else {
                setTimeout(waitForToken, 30);
            }
        })();
    }

    logout() {
        // Ta bort token
        localStorage.removeItem('api_token');
        localStorage.removeItem('user_type');

        // Skicka tillbaka användaren till startsidan först efter att det är garanterat att token har tagits bort
        (function waitForToken() {
            if (!localStorage.getItem('api_token') && !localStorage.getItem('user_type')) {
                window.location.reload();
            } else {
                setTimeout(waitForToken, 30);
            }
        })();
    }
}

export default new Auth();



// WEBPACK FOOTER //
// ./src/Auth.js